import { render, staticRenderFns } from "./TestPremiumModals.vue?vue&type=template&id=de3cfaae&scoped=true&"
import script from "./TestPremiumModals.vue?vue&type=script&lang=js&"
export * from "./TestPremiumModals.vue?vue&type=script&lang=js&"
import style0 from "./TestPremiumModals.vue?vue&type=style&index=0&id=de3cfaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3cfaae",
  null
  
)

export default component.exports